export default __webpack_public_path__ + "static/media/icon-interdit.75859f2c.svg";